<div [innerHTML]="getColumnContent()"></div>
